import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, onMounted } from "vue";
import NavigationBar from "@/components/shared/NavigationBar.vue";
import { useBbsStore } from "@/stores/bbsStore";
import EmptyContent from "@/components/shared/EmptyContent.vue";
import Page from "@/components/shared/Page.vue";
import DOMPurify from "dompurify";
import { useValidateUrlLink } from "@/composables/shared/useValidateUrlLink";
import { useRoute } from "vue-router";
import { INoticeInfoData } from "@/domain/entities/bbs";
import ScrollTopControl from "@/components/shared/ScrollTopControl.vue";
import ZoomControl from "@/components/shared/ZoomControl.vue";


const __default__ = {
  name: "Notice",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose: __expose }) {
  __expose();

const bbsStore = useBbsStore();
const route = useRoute();
const initialNoticeId = route.query.initialNoticeId?.toString() ?? "";

const noticeInfos = computed(() => bbsStore.noticeInfos);

const scrollContainerRef = ref<HTMLElement>();

const noticeTitle = (notice: INoticeInfoData) => {
  const { title, campusName } = notice;
  return campusName ? `[${campusName}] ${title}` : title;
};

const setReadNoticeInfo = async (noticeId: string) => {
  await bbsStore.readNoticeInfo(noticeId);
};

// /** 공지사항을 여러개 펼칠 수 있다 */
// const selectedNoticeIdList = ref<string[]>(
//   initialNoticeId ? [initialNoticeId] : []
// );
// const onClickNotice = (noticeId: string, wasRead: boolean) => {
//   if (!wasRead) {
//     setReadNoticeInfo(noticeId);
//   }
//   if (isSelectedNotice(noticeId)) {
//     const index = selectedNoticeIdList.value.indexOf(noticeId);
//     selectedNoticeIdList.value.splice(index, 1);
//     return;
//   }
//   selectedNoticeIdList.value.push(noticeId);
// };

/** 공지사항을 한번에 하나씩만 펼칠 수 있다 */

const selectedNoticeId = ref<string>(initialNoticeId || "");

const onClickNotice = (noticeId: string, wasRead: boolean) => {
  if (!wasRead) {
    setReadNoticeInfo(noticeId);
  }

  // 선택된 공지사항을 fold 할 경우
  if (isSelectedNotice(noticeId)) {
    selectedNoticeId.value = "";
    return;
  }

  // 새로운 공지사항을 expand 할 경우
  selectedNoticeId.value = noticeId;
};

const isSelectedNotice = (noticeId: string) => {
  return selectedNoticeId.value.includes(noticeId);
};

const onExpandEnter = (element: Element) => {
  const htmlElement = element as HTMLElement;
  const ZOOM_CONTROL_HEIGHT_PX = 48;

  htmlElement.style.maxHeight =
    htmlElement.scrollHeight + ZOOM_CONTROL_HEIGHT_PX + "px";

  // 이미지 로드될 때 maxHeight 계산하도록 처리
  const images = htmlElement.querySelectorAll("img");
  images.forEach((image) => {
    image.onload = () => {
      htmlElement.style.maxHeight =
        htmlElement.scrollHeight + ZOOM_CONTROL_HEIGHT_PX + "px";
    };
  });
};
const onExpandLeave = (element: Element) => {
  (element as HTMLElement).style.maxHeight = "0px";
};

/** url 링크 유효성 검사 */
const { validateUrlLink } = useValidateUrlLink();

onMounted(() => {
  if (!initialNoticeId) return;

  const initialNotice = noticeInfos.value?.find(
    (noticeInfo) => noticeInfo.id === initialNoticeId
  );
  if (initialNotice?.wasRead) return;

  setReadNoticeInfo(initialNoticeId);
});

const __returned__ = { bbsStore, route, initialNoticeId, noticeInfos, scrollContainerRef, noticeTitle, setReadNoticeInfo, selectedNoticeId, onClickNotice, isSelectedNotice, onExpandEnter, onExpandLeave, validateUrlLink, NavigationBar, EmptyContent, Page, get DOMPurify() { return DOMPurify }, ScrollTopControl, ZoomControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})